import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static values = { url: String, xhr: Boolean };

    connect() {
        this.element[this.identifier] = this;
        if (this.hasUrlValue && this.xhrValue) {
            this.fetch();
        }
    }

    async fetch() {
        const url = this.urlValue || this.element.getAttribute("data-content-loader-url-value");
        if (!url) return;
        const response = await fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" }, credentials: 'same-origin' });
        const html = await response.text();
        this.element.innerHTML = html;
        // Contenu injecté dynamiquement : relancer l'enregistrement Stimulus sur ce sous-arbre
        // (évite les courses où les actions data-action ne sont pas encore actives).
        try {
            if (window.Stimulus && typeof window.Stimulus.load === "function") {
                window.Stimulus.load(this.element);
            }
        } catch (_) {}
        // Notifier les listeners que le contenu a été chargé
        try {
            this.element.dispatchEvent(new CustomEvent('content-loader:loaded', { bubbles: true, detail: { url } }));
        } catch (_) {}
    }

    lazyLoad() {
        this.element.innerHTML = '';
    }
}